var React = require( 'react' );
var createReactClass = require('create-react-class');
var MatrixRow = require('./matrixRow.jsx');

var Matrix = createReactClass({

  render: function() {

    var columnHeaders = this.props.choices.map(function(choice, key) {
      return (
        <div key={this.props.name + '-choice-' + key} className="option-column">
            <h5>{choice.label}</h5>
        </div>
      );
    }.bind(this));

    var rows = this.props.priorResponse.map(function(res, key) {
        var userResponse = {};
        for(var i = 0; i < this.props.currentResponse.length; i++){
            if(res.value === this.props.currentResponse[i].rowValue){
                userResponse = this.props.currentResponse[i];
                break;
            }
        }

      return (
        <MatrixRow
          name={res.tag}
          label={res.text}
          rowValue={res.value}
          choices={this.props.choices}
          key={key}
          userResponse={userResponse}
          handleResponse={this.props.response} />
      );
    }.bind(this));

    return (
      <div className="matrix">
          <div className="head">
              <div className="title">
                  <h4>&nbsp;</h4>
              </div>
              {columnHeaders}
          </div>
            {rows}
          <div className="foot"></div>
      </div>
    );
  }
});

module.exports = Matrix;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/matrix/matrix.jsx